import { createSlice, PayloadAction } from '@reduxjs/toolkit';

interface BillingBatchState {
  shouldFetch: boolean;
  hasSubmitted: boolean;
}

const initialState: BillingBatchState = {
  shouldFetch: false,
  hasSubmitted: false,
};

const billingBatchSlice = createSlice({
  name: 'billingBatch',
  initialState,
  reducers: {
    setHasSubmitted: (state, action: PayloadAction<boolean>) => {
      state.hasSubmitted = action.payload;
    },
    setShouldFetch: (state, action: PayloadAction<boolean>) => {
      state.shouldFetch = action.payload;
    }
  },
});

export const {
  setHasSubmitted,
  setShouldFetch,
} = billingBatchSlice.actions;

export default billingBatchSlice.reducer;
